import request from '@/utils/request'

export function selectCollageSet(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/collageSet/selectCollageSet?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addCollageSet(data) {
    return request({
        url: `api/serviceCenter/collageSet/addCollageSet`,
        method: 'post',
        data,
    })
}

export function upDateCollageSet(data) {
    return request({
        url: `api/serviceCenter/collageSet/upDateCollageSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteCollageSet(data) {
    return request({
        url: `api/serviceCenter/collageSet/bathDeleteCollageSet`,
        method: 'post',
        data,
    })
}



export function selectAllOrdinary(data) {
    return request({
        url: `api/serviceCenter/ordinaryCutting/selectAllOrdinary?access=${data}`,
        method: 'post',
        data,
    })
}

export function selectAllBorderlessGraveSet(data) {
    return request({
        url: `api/serviceCenter/borderlessGraveSet/selectAllBorderlessGraveSet?access=${data}`,
        method: 'post',
        data,
    })
}

export function selectAllSuperSet(data) {
    return request({
        url: `api/serviceCenter/superSet/selectAllSuperSet?access=${data}`,
        method: 'post',
        data,
    })
}

export function selectPanelName(data) {
    return request({
        url: `api/serviceCenter/setPanel/selectPanelName?access=${data}`,
        method: 'post',
        data,
    })
}


export function selectCarvingName(data) {
    return request({
        url: `api/serviceCenter/setCarving/selectCarvingName?access=${data}`,
        method: 'post',
        data,
    })
}
export function selectAllBacklitCharactersSet(data) {
    return request({
        url: `api/serviceCenter/backlitCharacters/selectAllBacklitCharactersSet?access=${data}`,
        method: 'post',
        data,
    })
}




